import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleTimeoutModal, refreshRequest, logout, updateExpiration } from '@defi/core-auth';
import * as moment from 'moment';
import Auth from '@defi/core-auth';
import { ReactReduxContext } from 'react-redux';
var TIMEOUT_MODAL_DURATION = 300;

function TimeoutModalHOC(TimeoutModal, store) {
  var TimeoutModalContainer =
  /*#__PURE__*/
  function (_Component) {
    _inherits(TimeoutModalContainer, _Component);

    function TimeoutModalContainer() {
      var _this;

      _classCallCheck(this, TimeoutModalContainer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeoutModalContainer).call(this));

      _this.resetCountdown = function (expiration) {
        var expiredTime = expiration || Number(_this.props.expiration);
        var bufferTime = expiredTime - 60;
        var currentTime = Math.floor(Date.now() / 1000);
        var sessionTime = bufferTime - currentTime;

        if (sessionTime) {
          if (sessionTime < 1) {
            _this.handleStay();
          } else {
            _this.startCountdown();

            _this.setState({
              timeLeft: sessionTime
            });
          }
        } else {
          _this.handleLogout();
        }
      };

      _this.checkExpiration = function () {
        if (Number(localStorage.expiration) !== Number(_this.props.expiration)) {
          clearInterval(_this.interval);

          if (!localStorage.expiration) {
            _this.handleLogout();
          }

          _this.props.updateExpiration(Number(localStorage.expiration)); //this.props.refreshRequest();


          return true;
        }
      };

      _this.startCountdown = function () {
        _this.interval = setInterval(function () {
          return _this.countdown();
        }, 1000);
      };

      _this.countdown = function () {
        var timeLeft = _this.state.timeLeft;
        if (!_this.ismounted) return;

        var expirationChanged = _this.checkExpiration();

        if (!expirationChanged) {
          _this.setState({
            timeLeft: _this.state.timeLeft - 1
          });

          if (timeLeft < TIMEOUT_MODAL_DURATION && timeLeft > 0) {
            if (!_this.props.open) {
              _this.props.toggleTimeoutModal(true);
            }

            var timeLeftFormatted = moment.duration(timeLeft * 1000);
            var seconds = timeLeftFormatted.seconds();
            var minutes = timeLeftFormatted.minutes();
            var secondsView = seconds > 9 ? seconds : '0' + seconds;
            var view = minutes + ':' + secondsView;

            _this.setState({
              clock: view
            });
          } else if (timeLeft < 1) {
            _this.handleLogout();
          }
        }
      };

      _this.close = function () {
        clearInterval(_this.interval);

        _this.props.toggleTimeoutModal(false);
      };

      _this.stay = function () {
        _this.props.refreshRequest();

        _this.close();
      };

      _this.handleLogout = function () {
        Auth.logout();

        _this.close();
      };

      _this.ismounted = false;
      _this.state = {
        timeLeft: 0,
        clock: '0:00'
      };
      return _this;
    }

    _createClass(TimeoutModalContainer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.ismounted = true;
        clearInterval(this.interval);
        this.resetCountdown(null);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        clearInterval(this.interval);
        this.ismounted = false;
      }
    }, {
      key: "componentWillUpdate",
      value: function componentWillUpdate(nextProps, nextState) {
        if (Number(nextProps.expiration) && Number(this.props.expiration) !== Number(nextProps.expiration)) {
          clearInterval(this.interval);
          this.resetCountdown(Number(nextProps.expiration));
        }
      }
    }, {
      key: "render",
      value: function render() {
        return (// <ReactReduxContext.Consumer>
          //   {({ store }) => {
          //     return (
          React.createElement(TimeoutModal, {
            open: this.props.open,
            handleLogout: this.handleLogout,
            clock: this.state.clock,
            stay: this.stay,
            store: store
          }) //     )
          //   }}
          // </ReactReduxContext.Consumer>

        );
      }
    }]);

    return TimeoutModalContainer;
  }(Component);

  var mapStateToProps = function mapStateToProps(state) {
    var timeoutModal = state.timeoutModal;
    return {
      expiration: timeoutModal.expirationTime,
      open: timeoutModal.modalIsOpen
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      toggleTimeoutModal: toggleTimeoutModal,
      refreshRequest: refreshRequest,
      updateExpiration: updateExpiration,
      logout: logout
    }, dispatch);
  };

  return connect(mapStateToProps, mapDispatchToProps)(TimeoutModalContainer);
}

export default TimeoutModalHOC;